<template>
    <div class="user-archive">
      <button class="btn" type="button" data-target="#modal-delete-coach" data-toggle="modal" data-dismiss="modal" v-if="isActive"> 
        <svg-icon icon="turn-on"/> 
        <template>{{ __('Archive dietitian') }}</template>
      </button>
      <form :action="`/coaches/${coach.id}/restore`" method="POST" v-else>
        <input type="hidden" name="_token" :value="csrf">
        <button class="btn" type="submit"> 
          <svg-icon icon="turn-on"/> 
          <template>{{ __('Activate the dietitian') }}</template>
        </button>
      </form>
    </div>
</template>

<script>
export default {
  props: {
    coach: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    } 
  },
  computed: {
    isActive() {
      return this.coach.deleted_at ? false : true
    }
  }
}
</script>
